import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;
const Subscription_URL = `${API_URL}/subscription`;

const listAllSubscription = () => {
  return axios.get(`${Subscription_URL}/list-all-subscription`).then((response) => {
    return response;
  });
};

const listAllPausedSubscription = (params?: any) => {
  return axios.get(`${Subscription_URL}/paused-subscription`, { params }).then((response) => {
    return response;
  });
};

const listExpiringSubscriptions = (params?: any) => {
  return axios
    .get(`${Subscription_URL}/expiring-subscriptions`, { params })
    .then((response) => {
      return response;
    });
};

const userSubscriptionViewDetailsApi = (id: any) => {
  return axios.get(`${Subscription_URL}/view-user-subscription/${id}`).then((response) => {
    return response;
  });
};

const updateSubscriptionStoreRoute = (data: any) => {
  return axios.put(`${Subscription_URL}/update-store-route`, data).then((response) => {
    return response;
  });
};

const getDailySubscriptionOrdersHistory = (data: any) => {
  return axios.post(`${Subscription_URL}/subscription-track-history`, data).then((response) => {
    return response;
  });
};
export {
  listAllSubscription,
  userSubscriptionViewDetailsApi,
  updateSubscriptionStoreRoute,
  getDailySubscriptionOrdersHistory,
  listAllPausedSubscription,
  listExpiringSubscriptions
};
